import { render, staticRenderFns } from "./EmailSent.vue?vue&type=template&id=25e6a6a6&scoped=true&"
import script from "./EmailSent.vue?vue&type=script&lang=js&"
export * from "./EmailSent.vue?vue&type=script&lang=js&"
import style0 from "./EmailSent.vue?vue&type=style&index=0&id=25e6a6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6a6a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
